/* eslint-disable @typescript-eslint/camelcase */
const data = {
  'Connected to cloud': 'Připojen k internetu',
  'Broken connection to cloud': 'Přerušeno spojení k internetu',
  refresh: 'Obnovit',
  created: 'Vytvořen',
  'queueStatus.closed': 'Closed',
  'queueStatus.open': 'Open',
  'queueStatusAction.showQueueSettings': 'Queue Settings',
  'queueActions.callNext': 'Další',
  'queueActions.callAgain': 'Znovu',
  'queueActions.callPrevious': 'Předchozí',
  'queueStatusAction.close': 'Zavřít frontu',
  'queueStatusAction.open': 'Otevřít frontu',
  'queueInfoButton.queueSize': 'délka fronty',
  'selectedQueue.queueHeader': 'Fronta č. %{number}',
  'queueTickets.tickets': 'Zařazení zákazníci',
  'queueTickets.commentCount': '%{smart_count} komentář |||| %{smart_count} komentáře |||| %{smart_count} komentářů',
  'queueTickets.callTicket': 'Zavolat',
  'localStatus.local': 'vystaven zde',
  'localStatus.remote': 'vystaven vzdáleně',
  'printedStatus.printed': 'vytištěn',
  'printedStatus.notPrinted': 'neni vytištěn',
  'selectedQueue.authError': 'Chyba autentizace',
  'selectedQueue.authErrorHeader': 'Zřejmě jste zadali nespravné autentizační údaje',
  'selectedQueue.authErrorCheckCredentials': 'Zkontrolujte, že jste zadali správné id a klíč',
  'selectedQueue.noQueueFound': 'Žádná fronta nebyla nalezena',
  'selectedQueue.noQueueFoundDetailsHeader': 'Nenalezli jsme žádnou připojenou frontu',
  'selectedQueue.noQueueFoundDetailsCBXPower': 'Zkontrolujte, že je ovládací panel zapnutý',
  'selectedQueue.noQueueFoundDetailsNoConnection': 'Zkontrolujte internetové připojení',
  'selectedQueue.noQueueFoundDetailsSettings': 'Zkontrolujte nastavení připojení k ovládacímu panelu',
  'selectedQueue.goToSettings': 'Přejít k nastavení',
  'selectedQueue.tryAgain': 'se zkuste připojit znovu',
  'selectedQueue.orDivider': '... nebo ...',
  'currentTicket.title': 'Právě obsluhujeme:',
  'currentTicket.previousTicket': 'Předchozí lístek:',
  settings: 'Nastavení',
  tryAgain: 'Zkusit znovu',
  back: 'Zpět',
  save: 'Uložit',
  'settingsPage.settings': 'Nastavení',
  'settingsPage.cbxHost.floatingLabel': 'Adresa CBX',
  'settingsPage.cbxHost.hintText': 'např. 10.0.0.1',
  'settingsPage.cbxPort.floatingLabel': 'CBX Port',
  'settingsPage.cbxPort.hintText': 'např. 8082',
  'settingsPage.cbxKey.floatingLabel': 'CBX id (pro autentizaci)',
  'settingsPage.cbxKey.hintText': 'např. cbx1',
  'settingsPage.cbxSecret.floatingLabel': 'CBX klíč (pro autentizaci)',
  'settingsPage.cbxSecret.hintText': 'např. password',
  'queueListPage.commentsHeader': 'Chat',
  'validUntil.title': 'platnost',
  'validUntil.today': 'platný dnes',
  'validUntil.tomorrow': 'platný do zítra',
  'validUntil.custom': 'platný do %{validUntil}',
  'validUntil.forever': 'platný stále',
  'commentVisibility.all': 'vše',
  'commentVisibility.queue': 'fronta %{queue}',
  'commentVisibility.ticket': 'lístek %{ticket}',
  'commentListItem.editComment': 'Upravit',
  'commentListItem.deleteComment': 'Smazat',
  'commentListItem.visibleForAll': 'Zobrazit všem frontám',
  'commentListItem.changeValidity': 'Změnit dobu platnosti',
  'commentListItem.changeVisibility': 'Změnit viditelnost',
  'dialog.editComment.title': 'Upravit komentář',
  'dialog.editComment.message': '',
  'dialog.deleteComment.title': 'Smazat komentář?',
  'dialog.deleteComment.message': '',
  'dialog.changeValidity.title': 'Změnit dobu platnosti komentáře?',
  'dialog.changeValidity.message': 'Komentář bude viditelný po zadanou dobu platnosti',
  'dialog.changeVisibility.title': 'Změnit viditelnost komentáře?',
  'dialog.changeVisibility.message': 'Rozšířit oprávnění zobrazení komentáře pro uživatele ze všech front?',
  'button.ok': 'Ok',
  'button.cancel': 'Zrušit',
  'addComment.fullView': 'Zpráva všem',
  'addComment.simpleView': 'Zpráva pro %{ticketNumber}',
  'datePicker.timeTitle': 'Time',
  eventForm: {
    formTitle: 'Reservation',
    title: 'Title',
    start: 'Start',
    end: 'End',
    status: 'Status',
    serviceId: 'Service',
    clientId: 'Client',
    resource: 'Resource',
    notes: 'Notes',
    submit: 'Submit'
  },
  calNavBar: {
    today: 'Today',
    views: {
      month: 'Month',
      week: 'Week',
      day: 'Day',
      agenda: 'Agenda'
    }
  },
  resourceList: {
    title: 'Employees',
    ALL: 'All employees'
  },
  rbcMessages: {
    date: 'Date',
    time: 'Time',
    event: 'Booking',
    allDay: 'All day',
    week: 'Week',
    work_week: 'Work week',
    day: 'Day',
    month: 'Month',
    previous: 'Previous',
    next: 'Next',
    yesterday: 'Yesterday',
    tomorrow: 'Tomorrow',
    today: 'Today',
    agenda: 'Agenda',
    noEventsInRange: 'No bookings in selected date range'
  },
  agendaPrintDlg: {
    formTitle: 'Print Agenda',
    date: 'Date',
    resource: 'Employee',
    print: 'Print'
  },
  agendaPrint: {
    loading: 'Loading...'
  }
};

export default data;
